class LocalStorage {
	static key = 'dr_forms_prefill';
	static fieldsToSave = ['firstname', 'lastname', 'email', 'phone', 'company', 'title', 'COUNTRY', 'STATE', 'industry'];
	static fieldClassPrefix = 'calc-';
	static fieldUrlPrefix = 'form_';

	constructor(drForm) {
		this.userInfo = {};
		try {
			this.preFillForm(drForm);
		} catch (e) {
			console.error(e);
			if (typeof Sentry !== 'undefined') {
				Sentry.captureException(e);
			}
		}
	}

	preFillForm(drForm) {
		let localInfo = LocalStorage.getLocalInfo();
		let urlParams = this.getUrlParams();
		this.userInfo = Object.assign({}, localInfo, urlParams);
		if (Object.keys(this.userInfo).length) {
			this.setFormFieldsValues(drForm);
		}
	}

	getUrlParams() {
		let params = {};
		let urlParams = location.search.slice(1).split('&');
		for (let i in urlParams) {
			let param = urlParams[i].split('=');
			if (param.length === 2 && param[0] && param[0].indexOf(LocalStorage.fieldUrlPrefix) === 0 && param[1]) {
				let key = param[0].replace(LocalStorage.fieldUrlPrefix, '');
				params[key] = decodeURIComponent(param[1]);
			}
		}
		return params;
	}

	setFormFieldsValues(drForm) {
		for (let i = 0; i < LocalStorage.fieldsToSave.length; i++) {
			let fieldName = LocalStorage.fieldsToSave[i];
			let field = drForm.querySelector(LocalStorage.getFieldSelector(fieldName));
			if (field && typeof this.userInfo[fieldName] !== 'undefined') {
				this.setFieldValue(field, this.userInfo[fieldName]);
			}
		}
	}

	setFieldValue(field, value) {
		if (field.tagName === 'SELECT') {
			let option = field.querySelector('option[data-value="' + value + '"]');
			if (option) {
				field.value = option.value;
			}
		} else {
			field.value = value;
		}
        jQuery(field).trigger('change');
	}

	static getFieldSelector(fieldName) {
		return '.' + LocalStorage.fieldClassPrefix + fieldName;
	}

	static getFieldValue(field) {
		let value = '';
		if (field.tagName === 'SELECT') {
			let option = field.querySelector('option:checked');
			if (option && typeof option.dataset.value !== 'undefined') {
				value = option.dataset.value;
			}
		} else {
			value = field.value;
		}

		return value;
	}

	static setLocalInfo(drForm) {
		let userInfo = {};
		for (let i = 0; i < LocalStorage.fieldsToSave.length; i++) {
			let fieldName = LocalStorage.fieldsToSave[i];
			let field = drForm.querySelector(LocalStorage.getFieldSelector(fieldName));
			if (field) {
				userInfo[fieldName] = LocalStorage.getFieldValue(field);
			}
		}
		localStorage.setItem(LocalStorage.key, JSON.stringify(userInfo));
	}

	static getLocalInfo() {
		return JSON.parse(localStorage.getItem(LocalStorage.key)) || {};
	}
}

export const setLocalStorageInfo = LocalStorage.setLocalInfo;
export const getLocalStorageInfo = LocalStorage.getLocalInfo;
export default LocalStorage;
